export enum ESlackOAuthTokenType {
  BOT = 'bot',
  USER = 'user'
}
